import React from "react";
import { useNavigate, useRouteError } from "react-router-dom";
import type { BaseError } from "core/utils/baseError";
import { RapButton } from "@dynata/rex-raptor";
import paths from "paths";

const ErrorElementPage: React.FC = () => {
    const error = useRouteError() as BaseError;
    const navigate = useNavigate();
    const context = error.context as { place: string, status: string };

    return <div className="center-div">
        <h1>{context.status}</h1>
        <p>{`${error.cause}`}</p>
        <RapButton onClick={() => navigate(`/${paths.authenticated.DASHBOARD}`)}>
            Go back home
        </RapButton>
    </div>
}

export default ErrorElementPage;
